export default "__VITE_ASSET__C1iHV1ED__"